import { css } from 'styled-components';
import token from 'styled-token';
import { inlineMediaQueryMixin } from '../inlineMediaQueryMixin';
import { mediaQueryMixin } from '../mediaQueryMixin';
import { spacingMixin } from '../spacingMixin';
var sizeCSS = inlineMediaQueryMixin('size', function (mediaProps) {
  return token('icons.sizes', function (iconSizes) {
    var size = mediaProps.size;
    if (iconSizes && iconSizes[size]) {
      var iconSize = iconSizes[size] + "px";
      return "\n                height: " + iconSize + ";\n                width: " + iconSize + ";\n            ";
    }
    return '';
  })(mediaProps);
});
var coloringCSS = function coloringCSS(props) {
  var status = props.status;
  return token({
    secondaryColor: "DetailedIcon." + status + ".secondaryColor",
    foregroundColor: "DetailedIcon." + status + ".foregroundColor",
    accentColor: "DetailedIcon." + status + ".accentColor",
    noFill: "DetailedIcon.noFill"
  }, function (_ref) {
    var secondaryColor = _ref.secondaryColor,
      foregroundColor = _ref.foregroundColor,
      accentColor = _ref.accentColor,
      noFill = _ref.noFill;
    return css([".DetailedIcon__secondary-color-fill{fill:", ";}.DetailedIcon__foreground-color-fill{fill:", ";}.DetailedIcon__accent-color-fill{fill:", ";}.DetailedIcon__no-fill{fill:", ";}"], secondaryColor, foregroundColor, accentColor, noFill);
  })(props);
};

/** @class DetailedIconMixin */
/** @method */
export var DetailedIconMixin = function DetailedIconMixin(props) {
  return token('DetailedIcon.defaultSize', function (defaultSize) {
    if (defaultSize === void 0) {
      defaultSize = 44;
    }
    return css(["display:inline-block;vertical-align:top;", " height:", "px;width:", "px;", " ", " ", ""], spacingMixin(props), defaultSize, defaultSize, coloringCSS(props), sizeCSS(props), mediaQueryMixin(function (mediaProps) {
      return sizeCSS(Object.assign({}, props, mediaProps));
    }));
  })(props);
};